const CONFIG = {
    BASE_API_URL: '/gra2021/api/'
    // BASE_API_URL: 'https://noc-dev.mborecki.pl/gra2021/api/',
}

export default CONFIG;
